import React from "react";
import Entities from "../../components/Entities";
import { getBookings, downloadBookingExport } from "../../API";

export async function loader() {
  return getBookings();
}

function Bookings() {
  return (
    <Entities
      shema={{
        searchFromServer: false,
        fields: [
          { name: "Name", propertyName: "name", search: true },
          { name: "Manufacturer", propertyName: "manufacturer", isObject: true },
          {
            name: "",
            renderCell: (entity, i) => (
              <td key={i} style={{ width: 1, whiteSpace: "nowrap" }}>
                <button
                  className="btn btn-sm btn-outline-success"
                  onClick={(e) => { e.stopPropagation(); downloadBookingExport(entity.id); }}
                >
                  Export
                </button>
              </td>
            ),
          },
        ],
      }}
    />
  );
}

export default Bookings;
